import { b as mdiUndo, c as mdiClose, d as mdiArrowRight } from "./mdi-DXu6GWVJ.mjs";
import { N as NcInputField } from "./NcInputField-kKgY_2GV.mjs";
import { u as useModelMigration } from "./useModelMigration-EhAWvqDD.mjs";
import { r as register, b as t50, c as t17, a as t } from "./_l10n-BEfeU7gr.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-BreCg8pX.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
register(t17, t50);
const NcInputFieldProps = new Set(Object.keys(NcInputField.props));
const _sfc_main = {
  name: "NcTextField",
  components: {
    NcIconSvgWrapper,
    NcInputField
  },
  // Allow forwarding all attributes
  inheritAttrs: false,
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    /**
     * Any [NcInputField](#/Components/NcFields?id=ncinputfield) props
     */
    // Not an actual prop but needed to show in vue-styleguidist docs
    // eslint-disable-next-line
    " ": {},
    // Reuse all the props from NcInputField for better typing and documentation
    ...NcInputField.props,
    /**
     * The `aria-label` to set on the trailing button
     * If no explicit value is set it will default to the one matching the `trailingButtonIcon`:
     *
     * @default 'Clear text'|'Save changes'|'Undo changes'
     */
    trailingButtonLabel: {
      type: String,
      default: ""
    },
    // Custom props
    /**
     * Specifies which material design icon should be used for the trailing
     * button.
     *
     * The `'arrowRight'` value is deprecated and will be removed in the next major version.
     * Use `'arrowEnd'` instead.
     *
     * @type {'close'|'arrowEnd'|'arrowRight'|'undo'}
     */
    trailingButtonIcon: {
      type: String,
      default: "close",
      validator: (value) => [
        "close",
        "arrowEnd",
        "arrowRight",
        "undo"
      ].includes(value)
    }
  },
  emits: [
    /**
     * Removed in v9 - use `update:modelValue` (`v-model`) instead
     *
     * @deprecated
     */
    "update:value",
    "update:modelValue",
    /** Same as update:modelValue for Vue 2 compatibility */
    "update:model-value"
  ],
  setup() {
    const model = useModelMigration("value", "update:value");
    return {
      model,
      mdiArrowRight,
      mdiClose,
      mdiUndo
    };
  },
  computed: {
    /**
     * Is the trailing button icon directional.
     * Meaning the icon needs to be flipped on RTL text flow.
     */
    isArrow() {
      return this.trailingButtonIcon === "arrowEnd" || this.trailingButtonIcon === "arrowRight";
    },
    propsAndAttrsToForward() {
      const predefinedLabels = {
        arrowEnd: t("Save changes"),
        arrowRight: t("Save changes"),
        close: t("Clear text"),
        undo: t("Undo changes")
      };
      return {
        // Proxy all the HTML attributes
        ...this.$attrs,
        // Proxy original NcInputField's props
        ...Object.fromEntries(Object.entries(this.$props).filter(([key]) => NcInputFieldProps.has(key))),
        // Adjust aria-label for predefined trailing buttons
        trailingButtonLabel: this.trailingButtonLabel || predefinedLabels[this.trailingButtonIcon]
      };
    }
  },
  methods: {
    /**
     * Focus the input element
     *
     * @public
     */
    focus() {
      this.$refs.inputField.focus();
    },
    /**
     * Select all the text in the input
     *
     * @public
     */
    select() {
      this.$refs.inputField.select();
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("NcInputField", _vm._g(_vm._b({ ref: "inputField", scopedSlots: _vm._u([!!_vm.$scopedSlots.icon || !!_vm.$slots.default || !!_vm.$scopedSlots.default ? { key: "icon", fn: function() {
    return [_vm._t("icon", function() {
      return [_vm._t("default")];
    })];
  }, proxy: true } : null, _vm.type !== "search" ? { key: "trailing-button-icon", fn: function() {
    return [_vm.isArrow ? _c("NcIconSvgWrapper", { attrs: { "directional": "", "path": _vm.mdiArrowRight } }) : _c("NcIconSvgWrapper", { attrs: { "path": _vm.trailingButtonIcon === "undo" ? _vm.mdiUndo : _vm.mdiClose } })];
  }, proxy: true } : null], null, true) }, "NcInputField", _vm.propsAndAttrsToForward, false), _vm.$listeners));
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const NcTextField = __component__.exports;
export {
  NcTextField as N
};
//# sourceMappingURL=NcTextField-D_IMz2MR.mjs.map
